// extracted by mini-css-extract-plugin
export var bottomSection = "OurCulture-module--bottomSection--m9DaP";
export var bottomText = "OurCulture-module--bottomText--PT6gV";
export var circleImage = "OurCulture-module--circleImage--Vck-U";
export var circleImageContainer = "OurCulture-module--circleImageContainer--6Mhzk";
export var description = "OurCulture-module--description--EVglc";
export var headerSection = "OurCulture-module--headerSection--KjqPs";
export var iconContainer = "OurCulture-module--iconContainer--DJiBD";
export var ourCultureWrapper = "OurCulture-module--ourCultureWrapper--KSYT6";
export var title = "OurCulture-module--title--9hvcz";
export var valueCard = "OurCulture-module--valueCard--XV0b-";
export var valueDescription = "OurCulture-module--valueDescription--il70a";
export var valueIcon = "OurCulture-module--valueIcon--ukYbE";
export var valueTitle = "OurCulture-module--valueTitle--BAdNW";
export var valuesContainer = "OurCulture-module--valuesContainer--JUUs1";